// ─── Hook ─────────────────────────────────────────────────────────────────────

import { useGetApiV1ExamCorrectExamAnswerid } from '@/shared/api/generated';

/**
 * Hook para carregar os detalhes completos de uma resposta a ser corrigida.
 *
 * Retorna dados enriquecidos da resposta: enunciado da questão, nome do aluno,
 * valor da resposta, completude anterior, comentário anterior e tipo de componente.
 *
 * @param answerId - ID da resposta (null desabilita a query)
 * @returns Dados completos da resposta com estado de loading/error
 *
 * @example
 * ```tsx
 * const { answer, isLoading } = useAnswerDetails(answerId);
 * ```
 */
export function useAnswerDetails(answerId: number | null) {
  const query = useGetApiV1ExamCorrectExamAnswerid(answerId ?? 0, {
    query: { enabled: answerId !== null },
  });

  return {
    answer: query.data,
    // `isPending` (não `isLoading`) — evita a mesma janela de falso "não carregando"
    // ao trocar `answerId` (navegação) ou alternar `enabled`. Ver `useAnswerInfo.ts`.
    isLoading: query.isPending,
    isError: query.isError,
  } as const;
}
